<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-8">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title" v-if="isBuyOffer()">Buy Offer <i class="fas fa-hashtag"></i>{{offer.offer_id}}</h4>
                        <h4 class="card-title" v-else>Sell Offer <i class="fas fa-hashtag"></i>{{offer.offer_id}}</h4>
                    </div>

                    <offer-overview :offer="offer"></offer-overview>
                </div>

                <global-gap-report :audit="offer.offer_props.audit" v-if="offer.offer_props.audit && offer.offer_props.audit.type === 'GLOBAL_GAP'"></global-gap-report>
                <r-s-p-o-report :audit="offer.offer_props.audit" v-if="offer.offer_props.audit && offer.offer_props.audit.type === 'RSPO'"></r-s-p-o-report>

                <div class="card" v-if="isOfferOwner()" :offer="offer">
                    <offer-trades :offer="offer"></offer-trades>
                </div>
            </div>
            <div class="col-4">
                <owner-sidebar v-if="isOfferOwner()" :offer="offer"></owner-sidebar>
                <buyer-counterparty-sidebar v-else-if="isSellOffer()" :offer="offer"></buyer-counterparty-sidebar>
                <seller-counterparty-sidebar v-else-if="isBuyOffer()" :offer="offer"></seller-counterparty-sidebar>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import OfferOverview from "./sections/OfferOverview";
    import OfferTrades from "./sections/OfferTrades";
    import BuyerCounterpartySidebar from "./sections/BuyerCounterpartySidebar";
    import SellerCounterpartySidebar from "./sections/SellerCounterpartySidebar";
    import OwnerSidebar from "./sections/OwnerSidebar";
    import GlobalGapReport from "../../common/audit/GlobalGapReport.vue";
    import RSPOReport from "../../common/audit/RSPOReport.vue";

    export default {
        name: "ViewOffer",
        props: ["offerid"],
        components: {GlobalGapReport, RSPOReport, OfferOverview, OfferTrades, BuyerCounterpartySidebar, SellerCounterpartySidebar, OwnerSidebar},
        data() {
            return {
                offer: {
                    offer_props: {
                        audit: {
                            auditor: {
                                auditor_id: null,
                                email: null,
                                org_id: null,
                                org_name: null
                            },
                            coop_name: null,
                            id: null,
                            status: null,
                            title: null,
                            type: null
                        },
                        commodity_speciality: []
                    },
                    attachments: [],
                    category: '',
                    city: '',
                    commodity_name: '',
                    commodity_props: {},
                    country: '',
                    created_at: '',
                    currency: '',
                    description: '',
                    email: '',
                    expires_at: '',
                    first_name: '',
                    freight: '',
                    last_name: '',
                    line1: '',
                    line2: '',
                    name: '',
                    offer_id: '',
                    period: '',
                    postal_code: '',
                    pricing_type: '',
                    quantity: '',
                    state: '',
                    status: '',
                    storage: '',
                    type: '',
                    unit_price: '',
                    unit: {
                        id: null,
                        name: '',
                        symbol: '',
                        base_unit: ''
                    },
                    user_id: '',
                    year: ''
                }
            };
        },
        beforeMount() {
            this.getOffer();
        },
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        methods: {
            getOffer() {
                $(".preloader").fadeIn();
                this.$http
                .get(`marketplaces/${this.currentOrg.marketplace_id}/offers/${this.offerid}`)
                .then(reply => {
                    $(".preloader").fadeOut();
                    this.offer = reply.data;
                });
            },
            isBuyOffer() {
                return this.offer.type === 'BUY';
            },
            isSellOffer() {
                return this.offer.type === 'SELL';
            },
            isOfferOwner() {
                return this.offer.user_id === this.currentUser.id;
            }
        }
    };
</script>

<style scoped>

</style>
